export default "__VITE_ASSET__DrH2Pr0L__"